<template>
  <div v-click-outside="closeRightSide" class="left-navigation" :class="{'collapsed': !isOpenRight, 'tablet': isTablet}">
    <div class="left-navigation-box">
      <div class="left-side">
        <button
          @click="handleToggleCollapsed"
          ref="toggleNav"
          class="toggle-nav"
          type="button">
          <span/>
          <span/>
          <span/>
        </button>
        <div :style="{backgroundImage: `url(${currentUser.thumbnailPath || '/app/img/profile_no_photo.png'})`}"
             class="photo"/>
        <ul class="external">
          <li
            :key="item.id"
            v-for="item in externals.records">
            <a
              :href="item.linkURL"
              :title="`${item.subTitle ? item.subTitle : item.title}`"
              target="_blank">
              <span :style="{backgroundImage: `url(${item.image})`}" class="company-logo"/>
            </a>
          </li>
        </ul>
      </div>
      <div class="right-side" v-show="isOpenRight">
        <vue-custom-scrollbar class="scroll-area">
          <div class="right-side-box">
            <img alt="" class="logo" src="../../../public/img/logo.png">
            <div class="user-detail"
                 v-click-outside="closeUserDetails"
                 :class="{'user-detail-open': isOpenedUserDetails}"
                 @click="isOpenedUserDetails = !isOpenedUserDetails">
              <div class="user-detail-box">
                <strong class="full-name">{{currentUser.fullName}}</strong>
                <span class="role">{{currentUser.role.title}}</span>
              </div>
              <div class="user-detail-drop">
                <ul>
                  <li>
                    <button @click="$router.push({name: 'Profile'})">{{L10n('edit-profile')}}</button>
                  </li>
                  <li>
                    <button @click="logout" class="btn-logout">{{L10n('logout')}}</button>
                  </li>
                </ul>
              </div>
            </div>
            <ul class="main-navigation">
              <left-navigation-item
                :key="item.name"
                :route="item"
                :user="currentUser"
                @change-nav-rout="handlerChangeRout"
                v-for="item in tree"/>
            </ul>
          </div>

          <span class="copyright">{{globalParameters.copyrights}}</span>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'LeftMenuIndex',
  components: {
    'left-navigation-item': () => import('./LeftNavigationItem')
  },
  data () {
    return {
      isOpenedUserDetails: false,
      isOpenRight: window.innerWidth > 1024
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.get('currentUser')
    },
    permissions () {
      return this.$store.getters.get('permissions')
    },
    tree () {
      return this.$router.options.routes[0].children
        .filter(value => {
          return !value.meta.hide && this.permission(this.permissions, value.meta.permission)
        })
    },
    externals () {
      return this.API('ExternalWebsites/GetAllDynamic?select=id,title,subTitle,image,linkURL')
    },
    globalParameters () {
      return this.$store.getters.get('globalParameters')
    },
    isTablet () {
      return window.innerWidth < 1024
    }
  },
  methods: {
    closeRightSide () {
      if (this.isTablet) {
        this.isOpenRight = false
      }
    },
    handlerChangeRout () {
      if (this.isTablet) {
        this.isOpenRight = false
      }
    },
    closeUserDetails () {
      this.isOpenedUserDetails = false
    },
    handleToggleCollapsed () {
      this.isOpenRight = !this.isOpenRight
    },
    logout () {
      let loading = this.$loading({ lock: true })
      this.$store.dispatch('accountLogout')
        .then(_ => {
          location.reload()
        })
        .catch(error => {
          loading.close()
          this.requestErrorHandler(error, this.L10n('general-error'))
        })
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="stylus">
  @import "../../assets/css/props.styl"
  /*LEft NAVIGATION*/
  .left-navigation {
    &.tablet{
      right-side
      .right-side {
        position absolute
        z-index 1000
        left 6rem
        top 0
        bottom 0
        right 0
      }
    }
    .left-navigation-box {
      display flex
      min-height 100%
    }
    .left-side {
      width 6rem
      background #04ace7
      padding 2.7rem 0.7rem
    }
    .right-side {
      position relative
      padding 0
      background #fff
      display flex
      flex-direction column
      justify-content space-between
      width 24rem
      border-right 1px solid #eeeeef
      max-height 100vh
      overflow-y auto
    }
    .scroll-area{
      padding 1.7rem 2rem
    }
    .toggle-nav {
      display block
      height 1.4rem
      width 2rem
      margin 0 auto 3rem
      background none
      border 0
      span {
        display block
        height 0.2rem
        background #fff
        margin 0 0 0.2rem
        &:last-child {
          margin-bottom 0
        }
      }
    }
    .photo {
      height 4.6rem
      width 4.6rem
      border-radius 50%
      border 3px solid #36bdec
      margin 0 auto 2.2rem
      background-size cover
    }
    .external {
      list-style none
      margin -15px 0 0
      > li {
        padding 15px 0 0
        > a {
          display block
          width: 2.4rem
          margin 0 auto
        }
      }
    }

    .company-logo {
      display block
      height: 2.4rem
      width: 2.4rem
      background-size cover
    }

    .logo {
      max-width 11.7rem
      margin 0 0 1.3rem
    }

    .user-detail {
      position relative
      z-index 20
      &.user-detail-open {
        .user-detail-drop {
          opacity 1
          height auto
          overflow visible
        }
        .full-name {
          color #09729b
          &::after {
            opacity 1
          }
        }
      }
      .user-detail-box {
        font-size 1.3rem
        color #65646c
        font-weight normal
        line-height 1.5
        cursor pointer
        &:hover {
          .full-name {
            color #09729b
            &::after {
              opacity 1
            }
          }
        }
      }
      .full-name {
        font-size 1.6rem
        display inline-block
        position relative
        padding 0 2.5rem 0 0
        transition color 0.3s ease
        &::before
        &::after {
          position absolute
          top 0.8rem
          right 0
          display block
          content ''
          height: 0.6rem
          width: 0.9rem
          background url('../../../public/img/left-navigation.png') no-repeat -10.8rem 0
        }
        &::after {
          background-position -10.8rem -0.9rem
          opacity 0
          transition opacity 0.3s ease
        }
      }
      span {
        display block
      }
      .user-detail-drop {
        position absolute
        top 100%
        left 0
        right 2rem
        transition all 0.3s ease
        opacity 0
        height 0
        overflow hidden
        ul {
          list-style none
          margin 0.4rem 0 0
          background #fff
          box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.2)
          border-radius 5px
          padding 1.6rem 2rem
          > li {
            line-height 1.4
            font-size 1.3rem

            padding 1.2rem 0 0
            &:first-child {
              padding-top: 0
            }
            button {
              background none
              border 0
              display inline-block
              line-height 1.2
              font-size 1.3rem
              color #65646c
              font-weight normal
              transition all 0.3s ease
              &:hover {
                color #09729b
              }
            }
          }
        }
      }
    }

    .main-navigation {
      list-style none
      margin 2rem 0 0
      > li {
        position relative
        &.router-link-active
        &.is-opened {
          > button {
            color #09729b
            .link-icon {
              &::after {
                opacity: 1
              }
            }
          }
        }
        &::before {
          display block
          content ''
          height 1px
          background #f0f1f3
          position absolute
          top 0
          right 0
          left 3.3rem
        }
        &:first-child {
          &::before {
            display none
          }
        }
        > button {
          display block
          width 100%
          background none
          border 0
          text-align left
          line-height 1.2
          font-size 1.4rem
          font-weight bold
          color #65646c
          padding 1.4rem 1rem 1.2rem 3.5rem
          position relative

          &.active
          &:hover {
            color #09729b
            .link-icon {
              &::after {
                opacity: 1
              }
            }
          }
          .title {
            display block
            margin 0 0 0.3rem
            text-transform uppercase
          }
          .children {
            font-size 1.1rem
            color rgba(101, 100, 108, 0.5)
            font-weight normal
            white-space nowrap
            text-overflow ellipsis
            width 100%
            overflow hidden
            display block
          }
          .link-icon {
            display block
            position absolute
            top 1.4rem
            left 0
            height 1.5rem
            width: 1.8rem
            &::before
            &::after {
              display block
              content ''
              position absolute
              top 50%
              left 50%
              transform translate(-50%, -50%)
              transition opacity 0.3s ease
              background url('../../../public/img/left-navigation.png') no-repeat 0 0
            }
            &::after {
              opacity: 0
            }
            &.icon-dashboard {
              &::after
              &::before {
                height 1.1rem
                width 1.5rem
                background-position -12rem 0
              }
              &::after {
                background-position -12rem -1.7rem
              }
            }
            &.icon-companies {
              &::after
              &::before {
                height 1.4rem
                width 1.8rem
                background-position -13.8rem 0
              }
              &::after {
                background-position -13.8rem -1.7rem
              }
            }
            &.icon-stock {
              &::after
              &::before {
                height 1.5rem
                width 1.3rem
                background-position -15.9rem 0
              }
              &::after {
                background-position -15.9rem -1.7rem
              }
            }
            &.icon-rfq {
              &::after
              &::before {
                height 1.5rem
                width 1.2rem
                background-position -17.5rem 0
              }
              &::after {
                background-position -17.5rem -1.7rem
              }
            }
            &.icon-customer-order {
              &::after
              &::before {
                height 1.5rem
                width 2.2rem
                background-position -31.1rem 0
              }
              &::after {
                background-position -31.1rem -1.7rem
              }
            }
            &.icon-supplier-order {
              &::after
              &::before {
                height 1.5rem
                width 1.8rem
                background-position -33.2rem 0
              }
              &::after {
                background-position -33.2rem -1.7rem
              }
            }
            &.icon-support {
              &::after
              &::before {
                height 1.5rem
                width 1.8rem
                background-position -34.9rem 0
              }
              &::after {
                background-position -34.9rem -1.7rem
              }
            }
            &.icon-purchase {
              &::after
              &::before {
                height 1.6rem
                width 2.1rem
                background-position -29rem 0
              }
              &::after {
                background-position -29rem -1.7rem
              }
            }
            &.icon-qi {
              &::after
              &::before {
                height 1.5rem
                width 1.5rem
                background-position -19rem 0
              }
              &::after {
                background-position -19rem -1.7rem
              }
            }
            &.icon-finance {
              &::after
              &::before {
                height 1.6rem
                width 2.1rem
                background-position -26.7rem 0
              }
              &::after {
                background-position -26.7rem -1.7rem
              }
            }
            &.icon-settings {
              &::after
              &::before {
                height 1.5rem
                width 1.5rem
                background-position -20.8rem 0
              }
              &::after {
                background-position -20.8rem -1.7rem
              }
            }
            &.icon-technical-settings {
              &::after
              &::before {
                height 1.5rem
                width 1.5rem
                background-position -22.6rem 0
              }
              &::after {
                background-position -22.6rem -1.7rem
              }
            }
            &.icon-bi {
              &::after
              &::before {
                height 1.6rem
                width 2.1rem
                background-position -24.4rem 0
              }
              &::after {
                background-position -24.4rem -1.7rem
              }
            }
          }
        }
      }
      ul {
        list-style none
        margin 0
        padding 0 0 0 3.5rem
        > li {
          padding 0 0 1.2rem
          line-height 1.1
          button {
            display inline-block
            background none
            border 0
            font-size 1.2rem
            line-height 1.1
            transition color 0.3s ease
            &:hover {
              color #09729b
            }
            .title{
              display block
              text-align left
              line-height 1.3
              &:first-letter{
                text-transform uppercase
              }
            }
          }
        }
      }

    }

    .copyright {
      font-size 1.1rem
      color rgba(101, 100, 108, 0.5)
    }
  }
  .temp-logout {
    background: red /*position absolute
    top 0
    left 0*/
  }
  .main-navigation {
    li.is-children {
      ul {
        display none
      }
      /*&.router-link-active,*/
      &.is-opened {
        ul {
          display block
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .page-content{
      flex-wrap wrap
    }
    .left-navigation {
      width 100%
      position absolute
      .left-navigation-box{
        height 0
        min-height unset
      }
      .left-side{
        position fixed
        z-index 21
        display flex
        justify-content space-between
        align-items center
        width 100%
        padding 0 2rem
        height header-height
      }
      .right-side{
        width 100%
        position fixed !important
        z-index 21
        top header-height !important
        left 0 !important
        height "calc(100vh - %s)" % header-height
      }
      .photo,
      .toggle-nav{
        margin 0
      }
      .external {
        display none
      }
    }
  }
</style>
